/**
 * @file App.tsx
 * @description Application root with routing for the Ultimind corporate website.
 */

import { HashRouter, Route, Routes } from 'react-router'
import HomePage from './pages/Home'
import AboutPage from './pages/About'
import SolutionsPage from './pages/Solutions'
import TechnologyPage from './pages/Technology'
import CaseStudiesPage from './pages/CaseStudies'
import ContactPage from './pages/Contact'
import { PageLayout } from './components/layout/PageLayout'

/**
 * App component sets up the router and page layout for all routes.
 */
export default function App() {
  return (
    <HashRouter>
      <PageLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/technology" element={<TechnologyPage />} />
          <Route path="/cases" element={<CaseStudiesPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </PageLayout>
    </HashRouter>
  )
}
